<template>
  <div class="login-container">
    <div class="login-card">
      <img src="@/assets/mutuus-logo.svg" alt="Mutuus Logo" class="login-logo" />
      <h1>Login</h1>
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="accessKey">Clave de Acceso</label>
          <input
            id="accessKey"
            v-model="accessKey"
            type="password"
            placeholder="Ingresa tu clave de acceso"
            required
            class="form-input"
          />
        </div>
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
        <CustomButton
          :text="isLoading ? 'Iniciando sesión...' : 'Iniciar sesión'"
          variant="secondary"
          :disabled="isLoading"
          @click="handleLogin"
        />
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ApiService } from '../services/apiService'
import CustomButton from '@/components/CustomButton.vue'

const router = useRouter()
const accessKey = ref('')
const error = ref('')
const isLoading = ref(false)

const handleLogin = async () => {
  if (!accessKey.value.trim()) {
    error.value = 'Por favor, ingresa tu clave de acceso'
    return
  }

  isLoading.value = true
  error.value = ''

  try {
    const apiService = new ApiService()
    const response = await apiService.post<{ apiKey: string; message: string }>('/login', {
      accessKey: accessKey.value,
    })

    localStorage.setItem('apiKey', response.apiKey)

    router.push('/groups')
  } catch (err) {
    error.value = 'Clave de acceso inválida. Por favor, intenta nuevamente.'
    console.error('Hubo un error: Login error ', err)
  } finally {
    isLoading.value = false
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #ffffff;
}

.login-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-logo {
  width: 140px;
  margin-bottom: 1.5rem;
  display: block;
}

.login-card h1 {
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.login-button {
  padding: 0.75rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.login-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  text-align: center;
  padding: 0.5rem;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
}
</style>
